// @flow
import twitter from '../../assets/img/about-us/social/twitter.png';
import linkedin from '../../assets/img/about-us/social/linkedin.png';
import github from '../../assets/img/about-us/social/github.png';
import url from '../../assets/img/about-us/social/link.png';

// Brocolis
import anson from '../../assets/img/about-us/anson.png';
import mauricio from '../../assets/img/about-us/mau.png';

// Perú
import giwah from '../../assets/img/about-us/giwah.png';
import gogo from '../../assets/img/about-us/gogo.png';
import enzo from '../../assets/img/about-us/enzo.png';
import alex from '../../assets/img/about-us/alejandro.png';
import renato from '../../assets/img/about-us/renato.png';
import llanos from '../../assets/img/about-us/llanos.png';
import luis from '../../assets/img/about-us/luis.png';
import joshua from '../../assets/img/about-us/joshua.png';
import joaquin from '../../assets/img/about-us/joaquin.png';
import vale from '../../assets/img/about-us/vale.png';
import carlo from '../../assets/img/about-us/carlo.png';
import jum from '../../assets/img/about-us/jum.png';
import kath from '../../assets/img/about-us/kath.png';
import marina from '../../assets/img/about-us/marina.png';

// Colombia
import andres from '../../assets/img/about-us/andres.png';
import alejandra from '../../assets/img/about-us/alejandra.png';
import juanDuque from '../../assets/img/about-us/juan_duque.png';

export type Member = {
  +fullName: string;
  +title: string;
  +words: string[];
  +image: any;
  +links: {
    facebook?: string;
    twitter?: string;
    linkedin?: string;
    github?: string;
    url?: string;
  };
};

export const social = {
  twitter,
  linkedin,
  github,
  url,
};

export const membersHead: Member[] = [
  {
    fullName: 'Anson Tou',
    title: 'Co-Founder & CEO',
    words: ['Helper', 'Curious', 'Connector'],
    image: anson,
    links: {
      twitter: 'https://twitter.com/ansontou',
      linkedin: 'https://www.linkedin.com/in/anson-tou-liu-9a326b33/'
    }
  },
  {
    fullName: 'Mauricio Jiménez',
    title: 'Co-Founder & COO',
    words: ['Dreamer', 'Ambitious', 'Soccer Addict'],
    image: mauricio,
    links: {
      linkedin: 'https://www.linkedin.com/in/mauriciojimenezalarco/'
    }
  },
];

export const membersPE: Member[] = [
  {
    fullName: 'Josue Villasante',
    title: 'Backend Engineer',
    words: ['Creative', 'Perseverant', 'Reliable'],
    image: joshua,
    links: {
      github: 'https://github.com/j-villasante',
    }
  },
  {
    fullName: 'Gi Wah Dávalos',
    title: 'Chief Technology Officer',
    words: ['Hard-Working', 'Persistent', 'Diligent'],
    image: giwah,
    links: {
      linkedin: 'https://www.linkedin.com/in/gi-wah-d%C3%A1valos-loo-19a130aa/',
      github: 'https://github.com/giwiro'
    }
  },
  {
    fullName: 'Gonzalo Diaz',
    title: 'Chief Product Officer',
    words: ['Strategist', 'Friend', 'Gamer'],
    image: gogo,
    links: {
      linkedin: 'https://www.linkedin.com/in/gonzalo-diaz-5a102069/'
    }
  },
  {
    fullName: 'Enzo Neyra',
    title: 'Frontend Engineer',
    words: ['Friendly', 'Creative', 'Gamer'],
    image: enzo,
    links: {
      linkedin: 'https://www.linkedin.com/in/enzo-israel-neyra-23690ba1/'
    }
  },
  {
    fullName: 'Alex Arévalo ',
    title: 'Chief Architect',
    words: ['Knowledgeable', 'Yearning', 'Sincere'],
    image: alex,
    links: {
      url: 'http://a.arevalo.xyz/'
    }
  },
  {
    fullName: 'Renato Aguirre',
    title: 'Head of UX / UI',
    words: ['Creative', 'Meticulous', 'Curious'],
    image: renato,
    links: {
      linkedin: 'https://www.linkedin.com/in/aguirrerenato/'
    }
  },
  {
    fullName: 'Christian Llanos',
    title: 'Software Engineer',
    words: ['Atento', 'Confiable', 'Creativo'],
    image: llanos,
    links: {
      linkedin: 'https://www.linkedin.com/in/christian-llanos-5a8319118/'
    }
  },
  {
    fullName: 'Luis Hermoza ',
    title: 'Community Manager',
    words: ['Team-player', 'Gamer', 'Proactivo'],
    image: luis,
    links: {
      linkedin: 'https://www.linkedin.com/in/luis-hermoza-4a122b155/'
    }
  },
  {
    fullName: 'Joaquín Añorga',
    title: 'Software Developer',
    words: ['Joyful', 'Curious', 'Helpful'],
    image: joaquin,
    links: {
      linkedin: 'https://www.linkedin.com/in/joaquin-alonso/',
      github: 'https://github.com/cafete',
      url: 'https://joaquinalonso.me/',
    }
  },
  {
    fullName: 'Valeria Diaz',
    title: 'UX / UI Designer',
    words: ['Intellectually curious', 'Creative thinker', 'Coffee-lover'],
    image: vale,
    links: {
      linkedin: 'https://www.linkedin.com/in/valeria-diaz-70053582/',
    }
  },
  {
    fullName: 'Carlo André Rojas',
    title: 'Head of Operations & Customer Service',
    words: ['Aventurero', 'Feliz', 'Emprendedor'],
    image: carlo,
    links: {
      linkedin: 'https://www.linkedin.com/in/carlo-rojas-baquero/',
    }
  },
  {
    fullName: 'Jum León',
    title: 'Customer Sucess Manager',
    words: ['Travel lover', 'Verano', 'Extrovertida'],
    image: jum,
    links: {
      linkedin: 'https://www.linkedin.com/in/jumleonwu/',
    }
  },
  {
    fullName: 'Kath Matta',
    title: 'Social Media Manager',
    words: ['Creativa', 'Servicial', 'Green lover'],
    image: kath,
    links: {
      linkedin: 'https://www.linkedin.com/in/katherine-matta-8932121ab/',
      url: 'https://www.behance.net/kathematta',
    }
  },
  {
    fullName: 'Marina Soto',
    title: 'Customer Sucess Manager',
    words: ['Proactiva', 'Friendly', 'Books lover'],
    image: marina,
    links: {
      linkedin: 'https://www.linkedin.com/in/marina-soto-276491171/',
    }
  },
];

export const membersCO: Member[] = [
  {
    fullName: 'Andres Villabona',
    title: 'CSO',
    words: ['Persistent', 'Curious', 'Energetic'],
    image: andres,
    links: {
      linkedin: 'https://www.linkedin.com/in/andres-villabona-546545a9/',
    }
  },
  {
    fullName: 'Alejandra Toro',
    title: 'Regional Operations Manager',
    words: ['Entregada', 'Arriesgada', 'Leal'],
    image: alejandra,
    links: {
      linkedin: 'https://www.linkedin.com/in/nayibe-alejandra-toro-agudelo-7969b8186/',
    }
  },
  {
    fullName: 'Juan David Duque',
    title: 'Regional Sales Manager',
    words: ['Curioso', 'Creativo', 'Respetuoso'],
    image: juanDuque,
    links: {
      linkedin: 'https://www.linkedin.com/in/juan-david-duque-toro-379232188/',
    }
  },
];



// WEBPACK FOOTER //
// ./src/modules/about-us/about-us.data.js